export default "__VITE_ASSET__CjgJWlYn__"